import { AttendanceManagementTranslations } from "./attendance-management-pt-br";

export const ATTENDANCE_MANAGEMENT_FR_FR: AttendanceManagementTranslations = {
	attendanceManagement: "Gestion des Services",
	environmentsAndTables: "Environnements et tables",
	createAndManageEnvironments:
		"Créez et gérez les environnements et tables de votre établissement.",
	searchByTable: "Rechercher par table",
	statusConfiguration: "Configuration du statut",
	filter: "Filtrer",
	tablesInService: "Tables en service",
	tablesNeedingAttention: "Tables nécessitant une attention",
	availableTables: "Tables disponibles",
	seeMore: "Voir plus",
	seeAll: "Voir tous",
	selectAll: "Sélectionner tous",
	loading: "Chargement...",
	paid: "Payé",
	statusLabel: {
		Available: "Disponible",
		InService: "En service",
		Paid: "Payé",
		InPayment: "En paiement",
		Blocked: "Bloqué",
	},
	statusDescription: {
		available: "Tables disponibles pour être ouvertes",
		inService1: "Tables avec service démarré.",
		inService2: "Tables sans interaction depuis:",
		inPayment: "Tables qui ont déjà commencé le paiement.",
		blocked: "Tables bloquées pour réservation ou inactivité.",
	},
	minutes: "minutes",
	emptyState: {
		title: "Aucune table trouvée",
		subtitle: "Aucune table disponible avec les filtres sélectionnés.",
	},
	form: {
		minutes: {
			required: "Le champ minutes est obligatoire",
			placeholder: "Entrez une valeur entre 1 et 120",
		},
		submit: "Enregistrer les modifications",
		successMessage: "Configuration enregistrée avec succès",
	},
	updateTimeLabel: "Heure de mise à jour",
	updateTimeValue: "Mis à jour le {{date}} à {{time}}",
	attendanceManagementAlert: {
		title: "Aucun événement ouvert",
		message: "L'opération sera lancée après l'ouverture de l'événement et vous pourrez suivre les statuts des tables.",
		openEvent: "Ouvrir l'événement",
	},
};
